import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from "components/CustomButtons/Button.js";
import { useMutation } from 'react-apollo';
import paths from "paths";
import { generatePath } from "react-router-dom";
import { injectIntl } from 'react-intl';
import { defaultColors } from "common/styles/configLayout.js";
import { useSnackbar } from "notistack";

// core components
import PageHeader from 'components-lib/PageHeader/PageHeader';
import { Grid } from "@material-ui/core";
import IconCard from 'components-lib/IconCard/IconCard';

import Step1 from "./WizardSteps/Step1.js";
import Step2 from "./WizardSteps/Step2.js";
import Step3 from "./WizardSteps/Step3.js";
import Step4 from "./WizardSteps/Step4.js";
import Step5 from "./WizardSteps/Step5.js";
import Box from "@material-ui/core/Box";
import clsx from 'clsx';
import StepConnector from '@material-ui/core/StepConnector';
import CAMPAIGN_CREATE from "queries/CampaignsQueries/campaignCreate"

import InfoIcon from '@material-ui/icons/Info';
import PhotoAlbumIcon from '@material-ui/icons/PhotoAlbum';
import RoomIcon from '@material-ui/icons/Room';
import SendIcon from '@material-ui/icons/Send';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';
import FFCampaignsIcon from 'components-lib/Icons/FFCampaignsIcon/FFCampaignsIcon';
import WcIcon from "@material-ui/icons/Wc";

import CAMPAIGN_DETAILS from 'queries/CampaignsQueries/campaignDetails';
import { useQuery } from 'react-apollo';


const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    completed: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);



const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: defaultColors.two,
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundColor: defaultColors.one,
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundColor: defaultColors.one,
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    floatRight: {
        float: "right"
    },
}));


const CampaignNewBidPage = (props) => {
    const classes = useStyles();
    const { history, intl, axios } = props;

    const [activeStep, setActiveStep] = useState(0);

    const [createCampaign] = useMutation(CAMPAIGN_CREATE);

    const [companyId, setCompanyId] = useState(null)

    // hooks - gender checkboxes  /////////////////////////
    const [checkedMen, setCheckedMen] = useState(true);
    const [checkedWomen, setCheckedWomen] = useState(true);
    const [checkedNA, setCheckedNA] = useState(true);
  
    const [ rangeMale, setRangeMale ] = useState(['R13_18', 'R19_34', 'R35_49', 'R50_']);
    const [ rangeFemale, setRangeFemale ] = useState(['R13_18', 'R19_34', 'R35_49', 'R50_']);
    const [ rangeUnknownGender, setRangeUnknownGender ] = useState(['R13_18', 'R19_34', 'R35_49', 'R50_']);

    const [rangeMaleChecked, setRangeMaleChecked] = useState({
        R13_18: true, R19_34: true, R35_49: true, R50_: true, });

    const [rangeFemaleChecked, setRangeFemaleChecked] = useState({
      R13_18: true, R19_34: true, R35_49: true, R50_: true, });
    
    const [ rangeUnknownGenderChecked, setRangeUnknownGenderChecked] = useState({
      R13_18: true, R19_34: true, R35_49: true, R50_: true, });

    // hooks - clone campaign //////////////////////
    const [initialValues, setInitialValues] = useState()

    // get data about campaign from step1
    const handleGetData = ( data ) => {
        setInitialValues( data )
    } 

     // Take data range age, when clone campaign ( step 3 )
    const activeTimes = initialValues  ? {
        campaignTimes: initialValues.activeTimes.map(({ __typename, ...rest }) => rest),
    } : [];

    // Take data range age, when clone campaign ( step 4 )
    const criteriaGender = initialValues  ? {
        genderFemaleAge: initialValues.criteria[0].genderFemaleAge,
        genderMaleAge: initialValues.criteria[0].genderMaleAge,
        genderUnknownAge: initialValues.criteria[0].unknownGenderAge
    } : [];

    const [ isBack, setIsBack ] = useState(false)
    const steps = getSteps();
    const { enqueueSnackbar } = useSnackbar();
    const handleNext = () => {
        setCompanyId(valuesStep1?.companyId)
        setIsBack( false )
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        if (activeStep === 0) setInitialData(valuesStep1)
        if (activeStep === 1) setInitialData(valuesStep2)
        if (activeStep === 2) setInitialData(valuesStep3)
        if (activeStep === 3) {
            setInitialData(valuesStep3);
            setTimes(times);
            setCriteria(criteria)
        }

        if (companyId !== valuesStep1?.companyId) {
            setInitialData({
                ...valuesStep1,
                mediaIds: [],
                minRepeatInterval: 0,
                budget: null,
                maxBid: undefined,
            });

            setCriteria({
                locationIds: ['*'],
                segmentIds: ['*'],
                companyIds: ['*'],
                zoneIds: ['*'],
            })
        }
    };    

    const handleBack = () => {
        setCompanyId(valuesStep1?.companyId)
        setIsBack( true )
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        if (activeStep === 0) setInitialData(valuesStep1)
        if (activeStep === 1) setInitialData(valuesStep2)
        if (activeStep === 2) setInitialData(valuesStep3)
        if (activeStep === 3) {
            setInitialData(valuesStep3);
            setTimes(times);
            setCriteria(criteria)
        }
    };
    function getSteps() {
        return [
            intl.formatMessage({ id: "campaigns.wizard.basicInfo" }),
            intl.formatMessage({ id: "campaigns.wizard.media" }),
            intl.formatMessage({ id: "campaigns.wizard.budgetAndTimePlan" }),
            intl.formatMessage({ id: 'campaigns.wizard.filters' }),
            intl.formatMessage({ id: "campaigns.wizard.confirm" }),
        ];
    }


    const [valid, setValid] = useState(false);
    const [times, setTimes] = useState([
        { weekDay: "Monday", from: "00:00", to: "23:59" },
        { weekDay: "Tuesday", from: "00:00", to: "23:59" },
        { weekDay: "Wednesday", from: "00:00", to: "23:59" },
        { weekDay: "Thursday", from: "00:00", to: "23:59" },
        { weekDay: "Friday", from: "00:00", to: "23:59" },
        { weekDay: "Saturday", from: "00:00", to: "23:59" },
        { weekDay: "Sunday", from: "00:00", to: "23:59" }
    ])
    const [criteria, setCriteria] = useState({
        locationIds: ["*"],
        segmentIds: ["*"],
        companyIds: ["*"],
        zoneIds: ["*"],   
    })

    // const { data: campData } = useQuery(CAMPAIGN_DETAILS, { variables: { id: campaignId }, skip: !campaignId });

    const [valuesStep1, setValuesStep1] = useState({});
    const [valuesStep2, setValuesStep2] = useState({});
    const [valuesStep3, setValuesStep3] = useState({});
    const [initialData, setInitialData] = useState({
        topicIds: [],
        mediaIds: [],
        maxBid: [],
        minRepeatInterval: 0,
        watermarkId: "Default",
    }
    )

    // ///////////////
    // ////////////// Clone Campaign //////////////////////////////
    // ///////////////
 
    useEffect( () => {
        if ( activeTimes && activeTimes.length > 0 ) setTimes( activeTimes.campaignTimes );  
    }, [ initialValues ])

    console.log( activeTimes.length )
 
    // If clone campaign, take data age from old campaign
    useEffect( () => {
            if ( criteriaGender.genderMaleAge ) setRangeMale(criteriaGender.genderMaleAge);
            if ( criteriaGender.genderFemaleAge ) setRangeFemale(criteriaGender.genderFemaleAge) 
            if ( criteriaGender.genderUnknownAge ) setRangeUnknownGender(criteriaGender.genderUnknownAge)
    }, [ criteriaGender.genderMaleAge, criteriaGender.genderFemaleAge, criteriaGender.genderUnknownAge ])

    // compare data range and if includes age range set true
    useEffect(() => {
        setRangeMaleChecked({
          R13_18: rangeMale.includes('R13_18') ? true : false,
          R19_34: rangeMale.includes('R19_34') ? true : false,
          R35_49: rangeMale.includes('R35_49') ? true : false,
          R50_: rangeMale.includes('R50_') ? true : false,
        });
        setRangeFemaleChecked({
          R13_18: rangeFemale.includes('R13_18') ? true : false,
          R19_34: rangeFemale.includes('R19_34') ? true : false,
          R35_49: rangeFemale.includes('R35_49') ? true : false,
          R50_: rangeFemale.includes('R50_') ? true : false,
        });
        setRangeUnknownGenderChecked({
          R13_18: rangeUnknownGender.includes('R13_18') ? true : false,
          R19_34: rangeUnknownGender.includes('R19_34') ? true : false,
          R35_49: rangeUnknownGender.includes('R35_49') ? true : false,
          R50_: rangeUnknownGender.includes('R50_') ? true : false,
        });

        // if do not have checkbox of age, set false checkbox
        rangeMale.length === 0 ? handleCheck( false, "men" ) : handleCheck( true, "men" );
        rangeFemale.length === 0 ? handleCheck( false, "women" ) : handleCheck( true, "women" );
        rangeUnknownGender.length === 0 ? handleCheck( false, "na" ) : handleCheck( true, "na" ); 

    }, [rangeMale, rangeFemale, rangeUnknownGender]);


    // ///////////////// Handle age checkboxes /////////////////////////////////

    // handle if click checkBox men, woman, N/A
    const handleCheck = ( boolean, value ) => {
        if ( value === "men" ) {
            !boolean ? setCheckedMen( false ) : setCheckedMen( true );
        } else if ( value === "women" ) {
            !boolean ? setCheckedWomen( false ) : setCheckedWomen( true );
        } else if ( value === "na" ) {
            !boolean ? setCheckedNA( false ) : setCheckedNA( true );
        }
    }

    // set all age checkBox false
    const handleFalseAll = ( setRangeChecked, setRange ) => {
        setRangeChecked(prevState => ({
        R13_18: false, R19_34: false, R35_49: false, R50_: false,
        }));
        setRange([])
    };  
    
    // set all age checkBox true
    const handleTrueAll = ( setRangeChecked, setRange ) => {
        setRangeChecked( prevState => ({
        R13_18: true, R19_34: true, R35_49: true, R50_: true,
        }));
        setRange(['R13_18', 'R19_34', 'R35_49', 'R50_'])
    };

    // handle checkBox men, women, N/A
    const handleCheckedAge = ( boolean, value ) => {
        if ( value === "men" ) {
            handleCheck( boolean, value );
            if ( boolean === true ) {  // if true set male true
                handleTrueAll( setRangeMaleChecked, setRangeMale )
            } else if ( boolean === false ) {
                handleFalseAll( setRangeMaleChecked, setRangeMale )
            }
        } else if ( value === "women" ) { // if true set women true
            handleCheck( boolean, value );
            if ( boolean === true ) {
                handleTrueAll( setRangeFemaleChecked, setRangeFemale )
            } else if ( boolean === false ) {
                handleFalseAll( setRangeFemaleChecked, setRangeFemale )
            }
        } else if ( value === "na" ) { // if true set N/A true
            handleCheck( boolean, value );      
            if ( boolean === true ) {
                handleTrueAll( setRangeUnknownGenderChecked, setRangeUnknownGender )
            } else if ( boolean === false ) {
                handleFalseAll( setRangeUnknownGenderChecked, setRangeUnknownGender )      
            }
        }
    }

    // handle checkBox age, checked or not
    const handleCheckBox = ( boolean, value ) => {

        if ( value === 'menR13_18' ) handleCheckBoxToggle('R13_18', rangeMaleChecked, setRangeMaleChecked, setRangeMale );
        if ( value === 'menR19_34' ) handleCheckBoxToggle('R19_34', rangeMaleChecked, setRangeMaleChecked, setRangeMale );
        if ( value === 'menR35_49' ) handleCheckBoxToggle('R35_49', rangeMaleChecked, setRangeMaleChecked, setRangeMale );
        if ( value === 'menR50_' ) handleCheckBoxToggle('R50_', rangeMaleChecked, setRangeMaleChecked, setRangeMale );

        if ( value === 'womenR19_34' ) handleCheckBoxToggle('R19_34', rangeFemaleChecked, setRangeFemaleChecked, setRangeFemale );
        if ( value === 'womenR13_18' ) handleCheckBoxToggle('R13_18', rangeFemaleChecked, setRangeFemaleChecked, setRangeFemale );
        if ( value === 'womenR35_49' ) handleCheckBoxToggle('R35_49', rangeFemaleChecked, setRangeFemaleChecked, setRangeFemale );
        if ( value === 'womenR50_' ) handleCheckBoxToggle('R50_', rangeFemaleChecked, setRangeFemaleChecked, setRangeFemale );
        
        if ( value === 'naR19_34' ) handleCheckBoxToggle('R19_34', rangeUnknownGenderChecked, setRangeUnknownGenderChecked, setRangeUnknownGender );
        if ( value === 'naR13_18' ) handleCheckBoxToggle('R13_18', rangeUnknownGenderChecked, setRangeUnknownGenderChecked, setRangeUnknownGender );
        if ( value === 'naR35_49' ) handleCheckBoxToggle('R35_49', rangeUnknownGenderChecked, setRangeUnknownGenderChecked, setRangeUnknownGender );
        if ( value === 'naR50_' ) handleCheckBoxToggle('R50_', rangeUnknownGenderChecked, setRangeUnknownGenderChecked, setRangeUnknownGender );
    }

    // remove value from array
    const handleRemoveValue = ( setRange ,valueToRemove ) => {
        setRange(prevRange => prevRange.filter(value => value !== valueToRemove));
    };

    // toogle if click on age from to
    const handleCheckBoxToggle = (value, rangeChecked , setRangeChecked, setRange ) => {
        setRangeChecked(prevState => ({
        ...prevState,
        [value]: !prevState[value]
        }));

        // remove value if false or ad value
        // const numericValue = `R${value.substring(5)}`;
        const numericValue = `${value}`;
        if (rangeChecked[value]) {
        handleRemoveValue( setRange, numericValue )
        } else {
        setRange(prevRange => [...prevRange, `${numericValue}`]);
        }
    };

     // if do not have checkbox of age, set false checkbox male or female or na
    // useEffect( () => { 
    //     rangeMale.length === 0 ? handleCheck( false, "men" ) : handleCheck( true, "men" );
    //     rangeFemale.length === 0 ? handleCheck( false, "women" ) : handleCheck( true, "women" );
    // }, [ rangeMale, rangeFemale ])

    // if do not have checkbox of age, set false checkbox male or female or na
    // useEffect( () => {
    //     rangeUnknownGender.length === 0 ? handleCheck( false, "na" ) : handleCheck( true, "na" ); 
    // }, [ rangeUnknownGender ])


    function getStepContent(step) {
        switch (step) {
            case 0:
                return <Step1
                    initialData={ initialData }
                    callback={(newValue) => setValuesStep1(newValue)}
                    callbackValid={(newValue) => setValid(newValue)}
                    isBack={ isBack }
                    onGetData={ handleGetData }
                />;
            case 1:
                return <Step2
                    initialData={initialData}
                    initialValues={initialValues}
                    callback={(newValue) => setValuesStep2(newValue)}
                    callbackValid={(newValue) => setValid(newValue)}                    
                    values={valuesStep2}
                    companyId={valuesStep1?.companyId}
                    isBack={ isBack }
                />;
            case 2:
                return <Step3
                    initialData={initialData}
                    initialValues={initialValues}
                    axios={axios}
                    callback={(newValue) => setValuesStep3(newValue)}
                    callbackValid={(newValue) => setValid(newValue)}
                    companyId={valuesStep1?.companyId}
                    callbackTimes={(newValue) => setTimes(newValue)}
                    times={times}
                    criteria={criteria}
                    callbackCriteria={(newValue) => setCriteria(newValue)}
                    isBack={ isBack }
                />;
            case 3:
                return <Step4
                    checkedMen={checkedMen}
                    checkedWomen={checkedWomen}
                    checkedNA={checkedNA}
                    rangeMaleChecked={rangeMaleChecked}
                    rangeFemaleChecked={rangeFemaleChecked}
                    rangeUnknownGenderChecked={rangeUnknownGenderChecked}
                    onCheckedAge={handleCheckedAge}
                    onCheckBox={handleCheckBox}
                    page={ 'page4' }
                />;
            case 4:
                return <Step5
                    companyId={valuesStep1?.companyId}
                    initialData={{
                        ...valuesStep1,
                        ...valuesStep2,
                        ...valuesStep3,
                    }}
                    times={times}
                    criteria={criteria}
                    rangeMale={rangeMale}
                    rangeFemale={rangeFemale}
                    rangeUnknownGender={rangeUnknownGender}
                />;
            default:
                return 'Unknown step';
        }
    }

    const setTitle = (active) => {
        if (activeStep === 0) return intl.formatMessage({ id: "campaigns.wizard.basicInfo.description" })
        else if (activeStep === 1) return intl.formatMessage({ id: "campaigns.wizard.media.description" })
        else if (activeStep === 2) return intl.formatMessage({ id: "campaigns.wizard.budgetAndTimePlan.description" })
        else if (activeStep === 3) return intl.formatMessage({ id: "campaigns.wizard.age.filters" })
        else return intl.formatMessage({ id: "campaigns.wizard.confirm.description" })
    }

    const handleCreateCampaign = () => {

        let helpCriteria = {
            locationIds: (criteria?.locationIds[0] === "*") ? [] : criteria?.locationIds,
            segmentIds: (criteria?.segmentIds[0] === "*") ? [] : criteria?.segmentIds,
            companyIds: (criteria?.companyIds[0] === "*") ? [] : criteria?.companyIds,
            zoneIds: (criteria?.zoneIds[0] === "*") ? [] : criteria?.zoneIds,
            genderMaleAge: (rangeMale.length === 0) ? ['Unknown'] : rangeMale,
            genderFemaleAge: (rangeFemale.length === 0) ? ['Unknown'] : rangeFemale,
            unknownGenderAge: (rangeUnknownGender.length === 0) ? ['Unknown'] : rangeUnknownGender,
        }

        let inputData = {
            ...valuesStep1,
            ...valuesStep2,
            ...valuesStep3,
            watermarkId: (!valuesStep2?.watermarkId || valuesStep2?.watermarkId === "Default") ? undefined : valuesStep2?.watermarkId,
            activeTimes: times,
            type: "FreePhoto",
            criteria: helpCriteria
        }
        // console.log( inputData )
        createCampaign({
            variables: {
                input: inputData
            }
        }).then((response) => {
            history.push(`/admin${generatePath(paths.campaigns.FreePhoto)}`)
            enqueueSnackbar(intl.formatMessage({ id: "campaigns.create.success" }), { variant: 'success' });
        }).catch((err) => {
            console.log(err);
            console.log( inputData )
        });
    };

    //Minimalny interval opakovania pre pouzivatela (dni)
    function ColorlibStepIcon(props) {
        const classes = useColorlibStepIconStyles();
        const { active, completed } = props;

        const icons = {
            1: <InfoIcon />,
            2: <PhotoAlbumIcon />,
            3: <RoomIcon />,
            4: <WcIcon />,
            5: <SendIcon />,
        };

        return (
            <div
                className={clsx(classes.root, {
                    [classes.active]: active,
                    [classes.completed]: completed,
                })}
            >
                {icons[String(props.icon)]}
            </div>
        );
    }


    return (
        <>
            <PageHeader
                title={intl.formatMessage({ id: "campaigns.new.freeFoto.title" })}
                handleBackAction={(e) => history.goBack()}
            />
            <Grid item><br /></Grid>
            <Grid container justify="center">
                <Grid item sm={8}>
                    <IconCard
                        icon={<FFCampaignsIcon raw={true} />}
                        title={setTitle(activeStep)}
                    >
                        <Grid item><hr /></Grid>
                        <Grid item>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>

                            {getStepContent(activeStep)}

                            <Box className={classes.floatRight}>
                                {(activeStep !== 0) &&
                                    <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                                        {intl.formatMessage({ id: 'deviceDetail.status.back' })}
                                    </Button>
                                }

                                <Button
                                    disabled={valid ? false : true}
                                    variant="contained"
                                    color="success"
                                    onClick={(activeStep === 4) ? handleCreateCampaign : handleNext}
                                >
                                    {activeStep === steps.length - 1 ? intl.formatMessage({ id: 'notificationsPage.modal.submit' }) : intl.formatMessage({ id: 'notificationsPage.stepperTitle.continueButton' })}
                                </Button>
                            </Box>
                        </Grid>

                    </IconCard>
                </Grid>
            </Grid>
        </>
    );
}

export default injectIntl(CampaignNewBidPage);